import { useTranslation } from 'react-i18next'
import { LoginForm } from '@/auth/LoginForm'

export function Login() {
  const { t } = useTranslation()
  return (
    <main className="min-h-screen bg-background text-foreground flex items-center justify-center p-4">
      <div className="w-full max-w-md flex flex-col gap-6 rounded-lg border p-6">
        <header className="flex flex-col gap-1">
          <h1 className="text-2xl font-bold tracking-tight">{t('auth.login.title')}</h1>
          <p className="text-sm text-muted-foreground">{t('auth.login.intro')}</p>
        </header>
        <LoginForm />
      </div>
    </main>
  )
}
